import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import injectSheet from "react-jss";
import { Step, ButtonResponsive } from "folksam-ui";

import Answer from "./Answer";
import { formatUrl } from "hooks/FlowMachine/utils";
// import DescriptionList from "./DescriptionList";
import themeOverride from "./themeOverride";
import { ThemeProvider } from "react-jss";
import ViewportPadding from "components/ViewportPadding";
const styles = ({ theme }) => ({
  root: ({ isSubmitting }) => ({
    opacity: isSubmitting ? "0.6" : 1
  }),
  link: {
    fontSize: theme.textSizes.base,
    fontWeight: theme.fontWeights.semibold
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `2px solid ${theme.colors.primary1}`,
    color: theme.colors.white,
    margin: 0,
    padding: theme.padding.md
  },
  step: {
    margin: [0.5, 0]
  },
  footer: {
    display: "flex",
    justifyContent: "center"
  },
  footerBorder: {
    // borderBottom: `9px solid ${theme.colors.primary1}`
  }
});

const renderSteps = (data, t, classes) => {
  return Object.entries(data)
    .sort(([id, step]) => step.index)
    .map(([id, step]) => {
      const stepUrl = formatUrl(id);
      return (
        <div key={id} className={classes.step}>
          {Object.entries(step.formData).map(([title, value]) => (
            <Answer title={title} value={value} key={title} url={stepUrl} />
          ))}
        </div>
      );
    });
};

const ReviewStep = ({ classes, isSubmitting, onSubmit, allStepsFormData }) => {
  const { t } = useTranslation();
  return (
    <ViewportPadding>
      <div className={classes.root}>
        <div className={classes.description}>
          {/* <Hint>
            <Markdown source={t("step.review.description")} />
          </Hint> */}
        </div>

        <div>{renderSteps(allStepsFormData, t, classes)}</div>

        <ThemeProvider theme={{ theme: themeOverride }}>
          <div className={classes.footerBorder}>
            <Step.Footer>
              <div className={classes.footer}>
                <ButtonResponsive
                  isBusy={isSubmitting}
                  onClick={onSubmit}
                  primary2
                >
                  {t("flow.submit.label")}
                </ButtonResponsive>
              </div>
            </Step.Footer>
          </div>
        </ThemeProvider>
      </div>
    </ViewportPadding>
  );
};

ReviewStep.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  allStepsFormData: PropTypes.object
};

export default injectSheet(styles)(ReviewStep);
